/* eslint-disable react/forbid-prop-types */
import React from "react";

const FormInput = ({
  error,
  type = "text",
  register,
  maxlength = 255,
  onlyNumber = false,
  border,
  ...props
}) => {
  const borderClass = border ? " is-invalid" : "";
  const errClass = error ? " is-invalid" : "";

  const allowOnlyNumber = (event) => {
    event.target.value = event.target.value
      .slice(0, event.target.maxlength)
      .replace(/[^0-9]/g, "");
  };

  return (
    <>
      <input
        className={`form-control${errClass}${borderClass}`}
        {...register}
        {...props}
        maxLength={maxlength}
        onInput={onlyNumber ? allowOnlyNumber : null}
        type={type}
      />
      {error && <div className="alert alert-danger mt-2">{error}</div>}
    </>
  );
};

export default FormInput;
